import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

export function ShiftCancelHeader(): JSX.Element {
  return (
    <Stack
      spacing={2}
      alignItems="center"
      sx={{
        paddingTop: 12,
        paddingBottom: 6,
        paddingX: 6,
      }}
    >
      <Text
        variant="h2"
        color={(theme) => theme.palette.intent?.error.text}
        sx={{ textAlign: "center" }}
      >
        Cancel your shift?
      </Text>
      <Text
        variant="h6"
        color={(theme) => theme.palette.text.secondary}
        sx={{ textAlign: "center" }}
      >
        How this will impact your Clipboard Score
      </Text>
    </Stack>
  );
}
